/* eslint-disable react/no-danger */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react'

import { Throbber } from 'ui/throbber'
import { ErrorSection, Container, Header } from 'ui/page'
import { SectionHTML } from 'ui/page/page-section'

import { useLoader } from 'components/use-loader'

import { api } from 'api'
import { useHistory, useLocation } from 'router'

export const CustomPages = () => {
  const history = useHistory()
  const { pathname } = useLocation()

  const handleRedirect = (event) => {
    // check links only
    if (event.target.tagName !== 'A') return
    // ignore mail links
    if (event.target.href.startsWith('mailto:')) return
    // ignore same page links
    if (event.target.hash) return

    // external links
    if (event.target.origin !== window.location.origin) {
      event.target.setAttribute('rel', 'noopener noreferrer')
      event.target.setAttribute('target', '_blank')
      return
    }

    event.preventDefault()
    const path = event.target.href.replace(window.location.origin, '')
    history.push(path)
  }

  const { pending, error, result } = useLoader(api.portalPages.get, pathname)

  return pending ? (
    <Container className="custom-page user-content">
      <Throbber />{' '}
    </Container>
  ) : error ? (
    <Container className="custom-page user-content">
      <ErrorSection error={error?.error || error} />{' '}
    </Container>
  ) : (
    <>
      {result.stylesheet && <style>{result.stylesheet}</style>}
      <Header>
        <h1>{result.title}</h1>
      </Header>
      <Container className="custom-page user-content">
        <SectionHTML onClick={handleRedirect} html={result?.content} />
      </Container>
    </>
  )
}

export default CustomPages
